import { format, isAfter, isBefore, startOfDay } from 'date-fns';

import { DisabledDateData } from '@types';

export const CALENDAR_DISABLED_DAY_TOOLTIP_ID = 'calendar-disabled-day-tooltip';

export const isDateOutsideSelectableRange = (
  date: Date,
  disabledDateData?: DisabledDateData
): boolean => {
  if (!disabledDateData) {
    return false;
  }

  const day = startOfDay(date);

  if (
    disabledDateData.minDate &&
    isBefore(day, startOfDay(disabledDateData.minDate))
  ) {
    return true;
  }

  if (
    disabledDateData.maxDate &&
    isAfter(day, startOfDay(disabledDateData.maxDate))
  ) {
    return true;
  }

  return false;
};

export const renderDayWithDisabledTooltip = (
  date: Date,
  disabledDateData?: DisabledDateData
) => {
  const dayNumber = format(date, 'd');
  const isDisabled = isDateOutsideSelectableRange(date, disabledDateData);

  if (isDisabled && disabledDateData?.infoText) {
    return (
      <span
        data-tooltip-id={CALENDAR_DISABLED_DAY_TOOLTIP_ID}
        data-tooltip-content={disabledDateData.infoText}
      >
        {dayNumber}
      </span>
    );
  }

  return <span>{dayNumber}</span>;
};
